(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jf-before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jf-compare')) {
    customElements.define('jf-compare', class extends HTMLElement {
      connectedCallback() {
        const range = this.querySelector('.jf-ba__range');
        const set = (v) => this.style.setProperty('--pos', v + '%');
        set(range.value);
        range.addEventListener('input', () => set(range.value));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jf-color-modes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jf-color-modes')) customElements.define('jf-color-modes', class extends HTMLElement {
    connectedCallback() {
      const root = this.closest('.jf-cm'); if (!root) return;
      const label = this.querySelector('[data-label]');
      const layers = [...this.querySelectorAll('.jf-cm__layer')];
      root.querySelectorAll('.jf-cm__swatch').forEach((b) => b.addEventListener('click', () => {
        root.querySelectorAll('.jf-cm__swatch').forEach((x) => x.classList.toggle('is-active', x === b));
        this.style.setProperty('--glow', b.dataset.color);
        layers.forEach((l) => l.classList.toggle('is-active', l.dataset.layer === b.dataset.target));
        if (label) label.textContent = b.dataset.name;
      }));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jf-faq"] && !Shopify.designMode) return;
  try {
    
  function groupJellyflowFaq(root) {
  root.querySelectorAll('.jf-faq__a:not([data-grouped])').forEach((a) => {
    a.dataset.grouped = '1';
    a.querySelectorAll('li').forEach((item) => {
      const content = document.createElement('span');
      while (item.firstChild) content.appendChild(item.firstChild);
      item.appendChild(content);
    });
    [...a.children].forEach((el) => {
      const next = el.nextElementSibling;
      const isLabel = el.tagName === 'P' && el.children.length === 1 && el.firstElementChild.tagName === 'STRONG' && el.textContent.trim() === el.firstElementChild.textContent.trim();
      if (isLabel && next && /^(UL|OL)$/.test(next.tagName)) {
        const card = document.createElement('div');
        card.className = 'jf-faq__card';
        a.insertBefore(card, el);
        card.appendChild(el);
        card.appendChild(next);
      }
    });
  });
  }
  groupJellyflowFaq(document);
  document.addEventListener('shopify:section:load', (event) => groupJellyflowFaq(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jf-reviews-judgeme"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jf-judgeme')) customElements.define('jf-judgeme', class extends HTMLElement {
    connectedCallback() {
      this.page = 1; this.rating = 0; this.sort = 'most_recent';
      this.per = parseInt(this.dataset.perPage, 10) || 12;
      this.pageCache = new Map();
      this.total = parseInt(this.dataset.total, 10) || 0;
      try { this.hist = JSON.parse('{' + this.dataset.hist + '}'); } catch (e) { this.hist = {}; }
      this.pages = parseInt(this.dataset.totalPages, 10) || 1;
      this.grid = this.querySelector('[data-grid]'); this.tpl = this.querySelector('[data-card]');
      this.fallback = this.grid.hidden;
      this.querySelectorAll('[data-filter]').forEach((b) => b.addEventListener('click', () => { const r = parseInt(b.dataset.filter, 10); this.rating = this.rating === r ? 0 : r; this.page = 1; this.refresh(); }));
      this.querySelector('[data-clear]').addEventListener('click', () => { this.rating = 0; this.page = 1; this.refresh(); });
      this.querySelector('[data-sort]').addEventListener('change', (e) => { this.sort = e.target.value; this.page = 1; this.refresh(); });
      this.querySelector('[data-prev]').addEventListener('click', () => this.goTo(this.page - 1));
      this.querySelector('[data-next]').addEventListener('click', () => this.goTo(this.page + 1));
      const w = this.querySelector('[data-write]');
      if (w) w.addEventListener('click', async () => {
        const nat = this.querySelector('[data-native]'); if (!nat) return;
        w.disabled = true;
        try {
          if (!window.jdgm?.loadScript) return;
          if (!this.formReady) {
            const content = nat.querySelector('[data-native-content]');
            if (content) { nat.append(document.importNode(content.content, true)); content.remove(); }
            ['base.css', 'main.css', 'form.css'].forEach((path) => window.jdgm.loadCSS(window.jdgm.widgetPath(path)));
            await this.loadReviewDependency('widget/base.js', () => !!window.jdgm.$);
            await this.loadReviewDependency('widget/common.js', () => !!window.jdgm.initializeWidgets);
            await this.loadReviewDependency('widget/write_review_modal.js', () => !!window.jdgm._WriteReviewModal);
            await this.loadReviewDependency('widget/form.js', () => !!window.jdgm.openForm);
            await new Promise((resolve, reject) => {
              const deadline = Date.now() + 10000;
              const ready = () => {
                if (document.querySelector('.jdgm-write-review-modal')) return setTimeout(resolve, 100);
                if (Date.now() >= deadline) return reject(new Error('Review form unavailable'));
                setTimeout(ready, 100);
              };
              ready();
            });
            this.formReady = true;
          }
          nat.hidden = false;
          nat.querySelector('.jdgm-write-rev-link')?.click();
          window.scrollTo({ top: nat.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
        } catch { this.querySelector('[data-error]').hidden = false; } finally { w.disabled = false; }
      });
      document.addEventListener('click', (e) => { const a = e.target.closest && e.target.closest('a[href="#reviews"], a[href$="#reviews"]'); if (a) { e.preventDefault(); this.scrollHere(); } });
      const lb = this.querySelector('[data-lightbox]');
      this.addEventListener('click', (e) => { const z = e.target.closest && e.target.closest('[data-zoom]'); if (!z) return; e.preventDefault(); lb.querySelector('[data-lightbox-img]').style.backgroundImage = 'url("' + z.dataset.zoom + '")'; lb.querySelector('[data-lightbox-cap]').textContent = z.dataset.caption || ''; lb.hidden = false; document.body.style.overflow = 'hidden'; });
      const close = () => { lb.hidden = true; document.body.style.overflow = ''; };
      lb.addEventListener('click', close); document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !lb.hidden) close(); });
      this.addEventListener('contextmenu', (e) => { if (e.target.closest && e.target.closest('.jf-jm__photo, .jf-jm__pics, [data-lightbox]')) e.preventDefault(); });
      this.loadedCount = this.grid.children.length;
      this.committed = { page: 1, rating: 0, sort: this.sort };
      this.renderPager(); this.renderStatus();
      if (!this.fallback && this.total) {
        this.visibilityObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.visibilityObserver.disconnect();
            this.refresh();
          }
        }, { rootMargin: '700px 0px' });
        this.visibilityObserver.observe(this);
      }
    }
    loadReviewDependency(path, ready) {
      if (ready()) return Promise.resolve();
      return new Promise((resolve, reject) => {
        const deadline = Date.now() + 12000;
        let timer;
        const check = () => {
          if (ready()) { clearTimeout(timer); resolve(); }
          else if (Date.now() >= deadline) reject(new Error('Review form unavailable'));
          else timer = setTimeout(check, 50);
        };
        window.jdgm.loadScript(window.jdgm.CDN_HOST + path);
        check();
      });
    }
    reviewPhoto(source, width = 640) {
      if (!source) return '';
      try {
        const url = new URL(source, location.href);
        if (url.hostname === 'review-images.judgeme.com') url.searchParams.set('width', width);
        return url.href;
      } catch { return source; }
    }
    scrollHere() { window.scrollTo({ top: this.getBoundingClientRect().top + window.scrollY - 88, behavior: 'smooth' }); }
    // Page changes: bring the top of the list into view in the SAME frame as the card swap. The shopper clicked the
    // pager at the bottom; swapping first and smooth-scrolling ~1000px afterwards showed the grid changing height
    // under the cursor and then stuttered across freshly laid-out cards.
    scrollToList() {
      const bar = this.querySelector('.jf-jm__toolbar') || this.grid;
      const top = bar.getBoundingClientRect().top;
      if (top >= 96 && top <= window.innerHeight * 0.5) return;
      window.scrollTo({ top: top + window.scrollY - 112, behavior: 'instant' });
    }
    goTo(p) { if (p < 1 || p > this.pages || p === this.page) return; this.lastPage = this.page; this.page = p; this.refresh(); }
    countFor() { return this.rating ? (this.hist[this.rating] || 0) : this.total; }
    async refresh() {
      this.visibilityObserver?.disconnect();
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      const desired = { page: this.page, rating: this.rating, sort: this.sort };
      this.grid.classList.add('is-loading');
      this.grid.setAttribute('aria-busy', 'true');
      this.querySelector('[data-error]').hidden = true;
      this.querySelector('[data-range]').textContent = 'Loading reviews…';
      try {
        const u = new URL('https://judge.me/reviews/reviews_for_widget');
        const q = { url: this.dataset.shop, shop_domain: this.dataset.shop, platform: 'shopify', page: desired.page, per_page: this.per, product_id: this.dataset.product, sort_by: ({ most_recent: 'created_at', highest_rating: 'rating', lowest_rating: 'rating' })[desired.sort] || desired.sort };
        if (desired.rating) q.filter_rating = desired.rating;
        const readPage = async (page) => {
          u.search = new URLSearchParams({ ...q, page });
          const key = u.href;
          const cached = this.pageCache.get(key);
          if (cached && Date.now() - cached.time < 300000) return cached.data;
          const response = await fetch(key, { signal: request.signal });
          if (!response.ok) throw new Error('Reviews unavailable');
          const data = await response.json();
          this.pageCache.set(key, { data, time: Date.now() });
          return data;
        };
        let json;
        if (desired.sort === 'lowest_rating') {
          // Reverse the matching range from Judge.me's supported highest-rating order.
          const count = this.countFor();
          const start = Math.max(0, count - desired.page * this.per);
          const end = Math.max(0, count - (desired.page - 1) * this.per);
          const first = Math.floor(start / this.per) + 1;
          const last = Math.max(first, Math.ceil(end / this.per));
          const chunks = await Promise.all(Array.from({ length: last - first + 1 }, (_, i) => readPage(first + i)));
          if (chunks.some((chunk) => !Array.isArray(chunk.reviews))) throw new Error('Invalid review response');
          json = { ...chunks[0], reviews: chunks.flatMap((chunk) => chunk.reviews).slice(start % this.per, start % this.per + end - start).reverse() };
        } else {
          json = await readPage(desired.page);
        }
        const structured = Array.isArray(json.reviews);
        if (!structured && typeof json.html !== 'string') throw new Error('Invalid review response');
        const doc = structured ? null : new DOMParser().parseFromString(json.html, 'text/html');
        const revs = structured ? json.reviews : [...doc.querySelectorAll('.jdgm-rev')];
        if (!revs.length && !desired.rating && desired.sort === 'most_recent' && this.total) throw new Error('Empty review response');
        if (request !== this.request || !this.isConnected) return;
        const nums = doc ? [...doc.querySelectorAll('.jdgm-paginate__page[data-page]')].map((el) => parseInt(el.dataset.page, 10)).filter(Boolean) : [];
        const cards = revs.map((rev) => structured ? this.dataCard(rev) : this.card(rev));
        await this.prepareImages(cards, request.signal);
        if (request !== this.request || !this.isConnected) return;
        const changedPage = desired.page !== this.committed.page;
        this.pages = Math.max(1, Number(json.pagination?.total_pages) || (nums.length ? Math.max(...nums) : Math.ceil(this.countFor() / this.per)));
        this.grid.replaceChildren(...cards);
        if (changedPage) this.scrollToList();
        this.loadedCount = revs.length;
        this.grid.hidden = false;
        const fallback = this.querySelector('.jf-jm__fallback');
        if (fallback) fallback.hidden = true;
        this.fallback = false;
        this.committed = desired;
        this.querySelector('[data-empty]').hidden = revs.length > 0;
      } catch (error) {
        if (error.name === 'AbortError' || request !== this.request) return;
        Object.assign(this, this.committed);
        this.querySelector('[data-sort]').value = this.sort;
        this.querySelector('[data-error]').hidden = false;
      } finally {
        if (request === this.request) {
          this.grid.classList.remove('is-loading');
          this.grid.setAttribute('aria-busy', 'false');
          this.renderPager(); this.renderStatus();
        }
      }
    }
    async prepareImages(cards, signal) {
      const images = cards.flatMap((card) => [...card.querySelectorAll('.jf-jm__pics img')]);
      if (!images.length) return;
      await new Promise((resolve, reject) => {
        const abort = () => finish(new DOMException('Aborted', 'AbortError'));
        const timer = setTimeout(() => finish(new Error('Review photos timed out')), 12000);
        const finish = (error) => {
          clearTimeout(timer);
          signal.removeEventListener('abort', abort);
          error ? reject(error) : resolve();
        };
        signal.addEventListener('abort', abort, { once: true });
        if (signal.aborted) return abort();
        Promise.all(images.map(async (image) => {
          image.loading = 'eager';
          try {
            await image.decode();
            image.width = image.naturalWidth;
            image.height = image.naturalHeight;
          } catch {
            image.closest('button')?.remove();
          }
        })).then(() => finish(), finish);
      });
    }
    disconnectedCallback() { this.visibilityObserver?.disconnect(); this.request?.abort(); }
    dataCard(review) {
      const card = document.importNode(this.tpl.content.firstElementChild, true);
      const score = Math.max(1, Math.min(5, Number(review.rating) || 5));
      const stars = card.querySelector('[data-stars]');
      stars.setAttribute('aria-label', score + ' out of 5 stars');
      stars.textContent = '★'.repeat(score);
      const off = document.createElement('span'); off.className = 'jf-jm__off'; off.textContent = '★'.repeat(5 - score); stars.appendChild(off);
      const date = new Date(review.created_at);
      card.querySelector('[data-date]').textContent = Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString(undefined, { month: 'short', day: '2-digit', year: 'numeric' });
      card.querySelector('[data-title]').textContent = review.title || '';
      card.querySelector('[data-body]').innerHTML = review.body_html || '';
      const author = review.reviewer_name || 'Customer';
      card.querySelector('[data-author]').textContent = author;
      card.querySelector('[data-avatar]').textContent = (review.reviewer_initial || author.charAt(0)).toUpperCase();
      card.querySelector('[data-verified]').hidden = review.verified_buyer !== true;
      const pics = card.querySelector('[data-pics]');
      (review.pictures_urls || []).forEach((picture) => {
        const button = document.createElement('button'); button.type = 'button'; button.dataset.zoom = picture.huge || picture.original; button.dataset.caption = author;
        button.setAttribute('aria-label', 'View photo by ' + author);
        const image = document.createElement('img'); image.src = this.reviewPhoto(picture.huge || picture.original || picture.compact); image.alt = 'Customer photo'; image.loading = 'lazy'; image.draggable = false;
        button.appendChild(image); pics.appendChild(button);
      });
      if (review.reply_content) {
        const reply = card.querySelector('[data-reply]'); reply.hidden = false;
        const name = document.createElement('b'); name.textContent = review.shop_reply_name || 'Jellyflow';
        const body = document.createElement('div'); body.innerHTML = review.reply_content;
        reply.append(name, body);
      }
      return card;
    }
    card(rev) {
      const c = document.importNode(this.tpl.content.firstElementChild, true);
      const score = Math.max(1, Math.min(5, parseInt(rev.querySelector('.jdgm-rev__rating')?.dataset.score || '5', 10)));
      const st = c.querySelector('[data-stars]'); st.setAttribute('aria-label', score + ' out of 5 stars'); st.textContent = '★'.repeat(score); const off = document.createElement('span'); off.className = 'jf-jm__off'; off.textContent = '★'.repeat(5 - score); st.appendChild(off);
      const ts = rev.querySelector('.jdgm-rev__timestamp')?.dataset.content;
      c.querySelector('[data-date]').textContent = ts ? new Date(ts).toLocaleDateString(undefined, { month: 'short', day: '2-digit', year: 'numeric' }) : '';
      c.querySelector('[data-title]').textContent = rev.querySelector('.jdgm-rev__title')?.textContent.trim() || '';
      c.querySelector('[data-body]').innerHTML = rev.querySelector('.jdgm-rev__body')?.innerHTML || '';
      const author = rev.querySelector('.jdgm-rev__author')?.textContent.trim() || 'Customer';
      const pics = c.querySelector('[data-pics]');
      rev.querySelectorAll('.jdgm-rev__pic-img').forEach((img) => { const src = img.dataset.src || img.src; const a = document.createElement('button'); a.type = 'button'; a.dataset.zoom = src; a.dataset.caption = author; const i = document.createElement('img'); i.src = this.reviewPhoto(src); i.alt = ''; i.loading = 'lazy'; i.draggable = false; a.appendChild(i); pics.appendChild(a); });
      const reply = rev.querySelector('.jdgm-rev__reply-content'); if (reply) { const r = c.querySelector('[data-reply]'); r.hidden = false; r.innerHTML = '<b>' + (rev.querySelector('.jdgm-rev__reply-name')?.textContent.trim() || 'Jellyflow') + '</b>' + reply.innerHTML; }
      c.querySelector('[data-author]').textContent = author; c.querySelector('[data-avatar]').textContent = author.charAt(0).toUpperCase();
      c.querySelector('[data-verified]').hidden = !rev.querySelector('.jdgm-rev__buyer-badge');
      return c;
    }
    renderStatus() {
      const n = this.countFor(), from = this.loadedCount ? (this.page - 1) * this.per + 1 : 0, to = this.loadedCount ? from + this.loadedCount - 1 : 0;
      this.querySelector('[data-range]').textContent = this.loadedCount ? 'Showing ' + from + '–' + to + (this.sort === 'with_pictures' ? ' photo reviews' : ' of ' + n) : 'Showing 0 reviews';
      const chip = this.querySelector('[data-clear]'); chip.hidden = !this.rating; if (this.rating) chip.querySelector('[data-chip-label]').textContent = this.rating + ' star' + (this.rating === 1 ? '' : 's');
      const bars = this.querySelector('.jf-jm__bars'); bars.classList.toggle('is-filtering', !!this.rating);
      this.querySelectorAll('[data-filter]').forEach((b) => b.setAttribute('aria-pressed', parseInt(b.dataset.filter, 10) === this.rating ? 'true' : 'false'));
    }
    renderPager() {
      const nav = this.querySelector('[data-pages]'), nums = this.querySelector('[data-nums]');
      nav.hidden = this.pages < 2; nums.innerHTML = '';
      const win = new Set([1, this.pages, this.page - 1, this.page, this.page + 1].filter((p) => p >= 1 && p <= this.pages));
      let last = 0;
      [...win].sort((a, b) => a - b).forEach((p) => {
        if (p - last > 1) { const g = document.createElement('span'); g.className = 'jf-jm__gap'; g.textContent = '…'; nums.appendChild(g); }
        const b = document.createElement('button'); b.type = 'button'; b.className = 'jf-jm__num'; b.textContent = p; if (p === this.page) b.setAttribute('aria-current', 'page'); b.addEventListener('click', () => this.goTo(p)); nums.appendChild(b); last = p;
      });
      this.querySelector('[data-prev]').disabled = this.page <= 1; this.querySelector('[data-next]').disabled = this.page >= this.pages;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jf-social-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jf-marquee')) customElements.define('jf-marquee', class extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.jf-proof__track');
      if (!track) return;
      let visible = false;
      const update = () => { track.style.animationPlayState = visible && !document.hidden ? '' : 'paused'; };
      this.observer = new IntersectionObserver((entries) => { visible = entries.some((entry) => entry.isIntersecting); update(); });
      this.onVisibility = update;
      document.addEventListener('visibilitychange', update);
      this.observer.observe(this);
      update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
